import { ILoginParam, IQuestionItem } from '@/api/types'
import mitt from 'mitt'

export interface IRGToLFType {
  type: number
  id: number
  sort: number
  myAnswer: string | string[]
  childType?: number
  parentAnswer?: string[]
  parentId?: number
}

type Events = {
  leftClickItem: { type: number; id: number; order: number; childType: number }
  // nextStep: { type: number }
  // prevStep: { type: number }
  rightToLeftChange: IRGToLFType
  currentDataChange: IQuestionItem
  complete: any
  noticeClip: any
  message: string
  cheatNotice: number
  loginTest: Omit<ILoginParam, 'MachineName'>
  replacement: string
}

const emitter = mitt<Events>()

export default emitter
